import LogDisplay from '@/components/base/LogDisplay';

interface IncidentLogCardProps {
  title: string;
  logLines: string[];
}

export default function IncidentLogCard({ title, logLines }: IncidentLogCardProps) {
  return (
    <div className="bg-bg-panel border border-border-subtle rounded-xl p-5 md:p-6">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-xs font-mono text-text-muted uppercase tracking-wider">Today&apos;s incident</div>
          <h2 className="text-lg font-semibold text-text-primary mt-1">{title}</h2>
        </div>
        <span className="text-xs text-danger flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-danger animate-pulse" />
          LIVE
        </span>
      </div>
      <LogDisplay lines={logLines} animated />
    </div>
  );
}